import { useState } from 'react'
import { FilterOption } from '../../../../../types'

export const useFilterForm = ({
  onApply,
  onReset,
}: {
  onApply?: (filters: FilterOption[]) => void
  onReset?: VoidFunction
}) => {
  const [appliedFilters, setAppliedFilters] = useState<FilterOption[]>([])
  const [selectedFiltersInForm, setSelectedFiltersInForm] = useState<FilterOption[]>([])

  const handleClickFilter = (filter: FilterOption) => {
    setSelectedFiltersInForm(prev => {
      if (!prev.find(f => f.field === filter.field && f.value === filter.value)) {
        return [...prev, filter]
      }
      return prev
    })
  }

  const removeFilter = (filter: FilterOption) => {
    setSelectedFiltersInForm(prev => prev.filter(f => f.value !== filter.value))
  }

  const handleReset = () => {
    setSelectedFiltersInForm([])
    setAppliedFilters([])
    onReset?.()
  }

  const handleApply = filtersToApply => {
    setAppliedFilters(filtersToApply)
    onApply?.(filtersToApply)
  }

  const handleCancel = () => {
    setSelectedFiltersInForm(appliedFilters)
  }

  return {
    activeFilters: appliedFilters,
    selectedFiltersInForm,
    handleClickFilter,
    removeFilter,
    handleReset,
    handleApply,
    handleCancel,
  }
}
